import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAccountViewPreference } from "src/hooks/useAccountViewPreference";
import { Logger } from "src/log";

const LOGGER = new Logger("MissingRouteRedirect");

const PREFERENCE_ORDER = [
  "employee",
  "servicing",
  "broker",
  "borrower",
  "applicant",
  "conveyancer",
  "lender",
  "none",
] as const;

const MissingRouteRedirect = () => {
  const location = useLocation();
  const { preference, choices, setPreference } = useAccountViewPreference();

  useEffect(() => {
    if (choices.length === 1) {
      return;
    }
    const anotherChoice = PREFERENCE_ORDER.find((c) => c !== preference && choices.includes(c));
    if (anotherChoice) {
      setPreference(anotherChoice);
    }
  }, [preference, choices]);

  if (choices.length === 1) {
    LOGGER.warn("Could not find a matching route for: ", location.pathname);
    return <Navigate to="/" replace />;
  }

  return null;
};

export default MissingRouteRedirect;
